import React from "react";
import { SideNavItem as SideNavItemStyle } from "./style";

const SideNavItem = (props) => (
  <SideNavItemStyle {...props}>
    {props.icon}
    <p>{props.text}</p>
  </SideNavItemStyle>
);

export default SideNavItem;
